export default __webpack_public_path__ + "static/media/Transmit.50e09c84.svg";